import React from 'react';

export const component = props => (
  <svg
    style={{ width: '100%' }}
    aria-label={props.label}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 108.8 118.5"
  >
    <path
      fill={props.color}
      d="M53 118.5v-2.9h3v3zM108.8 59.3l-5.2 4.7a95.9 95.9 0 0 1-26 16 65.8 65.8 0 0 1-15 4 55.1 55.1 0 0 1-16.7-.1 76 76 0 0 1-28.5-11 97.5 97.5 0 0 1-17-13.3l-.4-.4.4-.4a94.9 94.9 0 0 1 22.7-16.5 75.6 75.6 0 0 1 19.7-7.2 54.3 54.3 0 0 1 16.4-1A72.5 72.5 0 0 1 88 43.3a96.1 96.1 0 0 1 19.6 14.4 6.2 6.2 0 0 1 .7.6 10.7 10.7 0 0 1 .6 1zM54.5 81.7a22.4 22.4 0 1 0-22.4-22.5 22.4 22.4 0 0 0 22.4 22.5zm15.1-42.9c6.7 5.3 10.3 12 10.3 20.4s-3.7 15.1-10.2 20.4a92.6 92.6 0 0 0 35.4-20.3 97.5 97.5 0 0 0-19-13.6 78.3 78.3 0 0 0-16.5-6.9zM4 59.4a92.1 92.1 0 0 0 35.4 20.3 25.4 25.4 0 0 1 0-40.7A91.7 91.7 0 0 0 4 59.3zM63.3 102.5l-2 2-6.6-6.6-6.9 6.8-2-2.2 8.7-8.6zM61.3 13.8l2 2.2-8.8 8.6-8.7-8.6 2-2.1 6.7 6.7zM25.3 18.3v12.3H13.2v-2.9h9.2v-9.4zM86.6 27.7H96v2.9H83.7V18.3h3zM25.3 100.3h-2.8v-9.5h-9.3v-2.9h12.1zM83.8 87.9h12.1v2.9h-9.2v9.4h-3zM53.1 8.5V5.7H56v2.8zM53.1 110H56v2.9h-2.9zM53.1 0H56v2.9h-2.9z"
    />
    <path
      fill={props.color}
      d="M56 14.2h-2.9v-2.9H56zM56 104.3v2.9h-2.9v-2.9zM19 22.1l-2 2-2-2 2-2zM17.1 94.3l1.9 2-2 1.8-1.8-1.9zM9 12.3l1.9 1.9-2 2-1.9-2zM100.1 12.2l2 2-2 2-2-2zM15 100.3l-2 2-2-2 2-2zM14.9 18l-2 2-2-2 2-2zM96 20.2l-1.9-2 2-1.9 1.9 1.9zM94 22.2l-2 2-2-2 2-2zM98.2 100.4l-2 2-2-2 2-1.9zM11 104.3l-2 2-2-2 2-2zM100.2 102.4l2 2-2 1.8-1.9-2zM92.2 98.3l-2-1.9 2-2 2 1.9zM54.5 66.4a7.3 7.3 0 0 1 0-14.6 7.5 7.5 0 0 1 7.3 7.3 7.3 7.3 0 0 1-7.3 7.3zM50 59.2a4.6 4.6 0 1 0 4.6-4.5 4.5 4.5 0 0 0-4.6 4.5z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/ServiceSVG/visualIdentitySVG.jsx